import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getUserTablesRest } from '../tableService';
import { GetUserTablesResponse } from '../tableServicesTypes';

interface GetUserTableParams {
  userId: string | undefined | null;
  tableUrl?: string | undefined;
}

interface GetTableResponse {
  data: GetUserTablesResponse;
}

const useGetUserTables = ({ userId, tableUrl }: GetUserTableParams): UseQueryResult<GetTableResponse, Error> => {
  return useQuery<GetTableResponse, Error>({
    queryKey: ['user-table', userId, tableUrl],
    queryFn: () => getUserTablesRest(userId, tableUrl),
    enabled: !!userId,
  });
};

export default useGetUserTables;
